import * as React from 'react';

const ProductFilterSVG = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    onClick={props.onClick}
  >
    <g clipPath='url(#clip0_1800_21446)'>
      <mask
        id='mask0_1800_21446'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <path d='M24 0H0V24H24V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_1800_21446)'>
        <path
          d='M18 6.75H21.75L22.5 4.5H18V2.25H15.75V9H18V6.75Z'
          fill='#FF0037'
        />
        <path
          d='M18 15H15.75V21.75H18V19.5083H21.75L22.5 17.2583H18V15Z'
          fill='#FF0037'
        />
        <path d='M9 9H6.75V15.75H9V13.5H21.75L22.5 11.25H9V9Z' fill='#FF0037' />
        <path d='M14.25 4.5H2.25L1.5 6.75H14.25V4.5Z' fill='#FF0037' />
        <path d='M1.5 19.5083H14.25V17.2583H2.25L1.5 19.5083Z' fill='#FF0037' />
        <path d='M5.25 11.25H2.25L1.5 13.5H5.25V11.25Z' fill='#FF0037' />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_1800_21446'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default ProductFilterSVG;
